<template>
  <!-- @vue-expect-error FIXME: Property 'click' does not exist on type 'unknown' -->
  <TextField
    id="mealplan-certificate"
    name="keystore.certificate.name"
    :label="translate(`${LOCALE_PREFIX}.form.certificate`)"
    :placeholder="translate(`${LOCALE_PREFIX}.form.certificatePlaceholder`)"
    :disabled="!editMealPlan"
    :required="editMealPlan"
    readonly
    @click="$refs.certificate.click()"
  />

  <input
    v-show="false"
    type="file"
    ref="certificate"
    accept=".pfx"
    @change="handleItcCertificateUpload"
  />
</template>

<script setup lang="ts">
import { useFileConverter, useTranslation } from '@centric-os/helpers';
import { storeToRefs } from 'pinia';
import { useField } from 'vee-validate';
import useGlobalToast from '@centric-os/components/src/core/messages/toast/composables/use-global-toast';
import { useFormStore } from '@centric-os/stores/form/use-form-store';
import { isNil } from 'lodash-es';
import { SitesLocalePrefix } from '../../../../../../enums';
import { useFinancialConfigStore } from '../../../../../../routes';
import { FinancialFormIDs } from '../../../enums';

// Set localization
const { translate } = useTranslation();
const LOCALE_PREFIX = SitesLocalePrefix.SITE_MEAL_PLAN;

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editMealPlan } = storeToRefs(fConfigStore);

// Set global toast
const { showErrorToast } = useGlobalToast();

// Set certificate file field
const { value: certificateFile } = useField('keystore.certificate.encoded_file');

// Set form store
const formStore = useFormStore();
const form = formStore.getForm(FinancialFormIDs.MEAL_PLAN_FORM);

// Set certificate file on change
const handleItcCertificateUpload = async (event: Event): Promise<void> => {
  const target = event.target as HTMLInputElement;

  const file = target.files?.[0];

  if (file) {
    const { getBase64 } = useFileConverter();

    const splitFile = ((await getBase64(file)) as string).split('base64,');
    const encodedFile = splitFile.length > 1 ? splitFile[1] : splitFile[0];
    certificateFile.value = encodedFile;

    // @ts-expect-error FIXME: Argument of type 'string' is not assignable to parameter of type 'never'.
    form.value?.setFieldValue('keystore.certificate.name', file.name);
    // @ts-expect-error FIXME: Property 'keystore' does not exist on type 'unknown'.
    if (isNil(certificateFile.value) || isNil(form.value?.values.keystore.certificate.name)) {
      certificateFile.value = null;
      // @ts-expect-error FIXME: Argument of type 'string' is not assignable to parameter of type 'never'.
      form.value?.setFieldValue('keystore.certificate.name', null);
      showErrorToast('could not upload certificate');
    }
  } else {
    certificateFile.value = null;
    // @ts-expect-error FIXME: Argument of type 'string' is not assignable to parameter of type 'never'.
    form.value?.setFieldValue('keystore.certificate.name', null);
    showErrorToast('could not upload certificate');
  }
};
</script>
